import React, { useEffect, useState } from "react";

function AdminPanel({ user }) {
    const [users, setUsers] = useState([]);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const isAdmin = user && user.email === "admin@pardo.com";

    const loadUsers = async () => {
        setLoading(true);
        setMessage("");
        const token = localStorage.getItem("pardo_token");
        if (!token) {
            setMessage("Necesitas iniciar sesion como administrador.");
            setLoading(false);
            return;
        }
        try {
            const response = await fetch(process.env.REACT_APP_API_URL || "https://pardo-backend-3fp6.onrender.com" + "/api/admin/users", {
                headers: { Authorization: "Bearer " + token }
            });
            const data = await response.json();
            if (response.ok) {
                setUsers(data.users || []);
            } else {
                setMessage(data.error || "Error al cargar usuarios");
            }
        } catch (err) {
            setMessage("Error de conexion: " + err.message);
        }
        setLoading(false);
    };

    useEffect(() => { loadUsers(); }, []);

    const deleteUser = async (id) => {
        if (!window.confirm("Eliminar este usuario?")) return;
        const token = localStorage.getItem("pardo_token");
        try {
            const response = await fetch(process.env.REACT_APP_API_URL || "https://pardo-backend-3fp6.onrender.com" + "/api/admin/users/" + id, {
                method: "DELETE",
                headers: { Authorization: "Bearer " + token }
            });
            const data = await response.json();
            if (response.ok) {
                setMessage("Usuario eliminado");
                loadUsers();
            } else {
                setMessage(data.error || "Error al eliminar");
            }
        } catch (err) {
            setMessage("Error de conexion: " + err.message);
        }
    };

    if (!isAdmin) {
        return <div style={{ padding: "40px", textAlign: "center" }}><h2>Acceso denegado</h2><p>Solo el administrador puede ver este panel.</p></div>;
    }

    return (
        <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
            <h2>Panel de Administracion</h2>
            {message && <p style={{ color: "#f44336" }}>{message}</p>}
            {loading ? <p>Cargando...</p> : null}
            {users.length > 0 && (
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead><tr style={{ background: "#667eea", color: "#fff" }}><th>Usuario</th><th>Email</th><th>Acciones</th></tr></thead>
                    <tbody>
                        {users.map(u => (
                            <tr key={u.id} style={{ borderBottom: "1px solid #ddd" }}>
                                <td>{u.username}</td><td>{u.email}</td><td>
                                    {u.email !== "admin@pardo.com" && <button onClick={() => deleteUser(u.id)}>Eliminar</button>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}

export default AdminPanel;
